module.exports = __webpack_public_path__ + "img/forest.72bf20a7.jpg";